import { render, staticRenderFns } from "./MountingItem.vue?vue&type=template&id=33337f7c&lang=pug&"
import script from "./MountingItem.vue?vue&type=script&lang=js&"
export * from "./MountingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports